import clsx from 'clsx/lite';

export function Main({
  children,
  className,
  ...props
}: React.HTMLProps<HTMLDivElement>) {
  return (
    <main className={clsx('flex grow flex-col', className)} {...props}>
      {children}
    </main>
  );
}
